/* eslint-disable global-require */
import React from 'react';
import styles from './css/Planner.styl';
import Questionnaire from '../Questionnaire';
import {FormControls} from '../../../../shared/library';
import {getGATags} from '../../../../shared/utilities/GAHelpers';
import appConfig from '../../../../../appConfig/AppConfig';
import classNames from 'classnames';
import backgroundImg from './assets/planning-hero.jpg';
import backgroundImgSmall from '../../../../../assets/planning.png';

const {Button, EnhancedTextInput} = FormControls;

class Planner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {zipCode: '', questionnaire: 'pending'};
    this.handleZipCodeChange = this.handleZipCodeChange.bind(this);
    this.handleZipCodeSubmit = this.handleZipCodeSubmit.bind(this);
    this.handleQuestionnaireClose = this.handleQuestionnaireClose.bind(this);
    this.handleQuestionnaireSubmit = this.handleQuestionnaireSubmit.bind(this);
  }

  handleZipCodeChange(event) {
    if (!isNaN(event.target.value) && event.target.value.length <= 5) {
      this.setState({zipCode: `${event.target.value}`});
    }
  }

  handleZipCodeSubmit(event) {
    event.preventDefault();
    if (this.state.zipCode.length >= 5) {
      // fire off event tracking
      getGATags({
        eventCategory: 'planning_question',
        eventAction: 'q_zip',
        eventLabel: this.state.zipCode,
      });
      this.setState({questionnaire: 'launched'});
    }
  }

  handleQuestionnaireClose() {
    this.setState({questionnaire: 'pending'});
  }

  handleQuestionnaireSubmit() {
    if (typeof document !== 'undefined' && document.location) {
      const leaveQuestionnarie = () => {
        this.setState({questionnaire: 'pending'});
        document.location.href = `${
          appConfig().vanityDomain
        }/funeral-homes/directory/search?City=&StateName=&ZipCode=${
          this.state.zipCode
        }`;
      };

      setTimeout(leaveQuestionnarie.bind(this), 1500);
    }
    this.setState({questionnaire: 'submitted'});
  }

  cta() {
    const disabled = this.state.zipCode.length < 5;

    return (
      <div className={styles.CtaBlock}>
        <h1 className={styles.Title}>Plan a Funeral</h1>
        <div className={styles.Form}>
          <form onSubmit={this.handleZipCodeSubmit}>
            <div className={styles.Heading}>
              Protect your loved ones from worry. Begin now to set up a reliable
              advance funeral plan.
            </div>
            <EnhancedTextInput
              name="postalCode"
              type="text"
              title="Zip Code"
              onChange={this.handleZipCodeChange}
              placeholder="Enter Zip Code"
              value={this.state.zipCode}
            />
            <Button
              className={classNames(
                styles.PrimaryButton,
                disabled ? styles.disabled : null
              )}
              type="submit"
            >
              Get Started
            </Button>
          </form>
        </div>
      </div>
    );
  }

  prompt() {
    return (
      <div className={styles.Prompt}>
        <div className={styles.PlanningHeroNarrow}>
          <img src={backgroundImgSmall} />
          {this.cta()}
        </div>
        <div className={styles.PlanningHeroWide}>
          <img src={backgroundImg} />
          {this.cta()}
        </div>
      </div>
    );
  }

  questionnaire() {
    if (this.state.questionnaire !== 'pending') {
      return (
        <div>
          <div className={styles.PModalBkgd}>
            <div className={styles.PModalContent}>
              <Questionnaire
                handleClose={this.handleQuestionnaireClose}
                handleSubmit={this.handleQuestionnaireSubmit}
              />
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  render() {
    const prompt = this.prompt();
    const questionnaire = this.questionnaire();

    return (
      <div className={styles.Planner}>
        {prompt}
        {questionnaire}
      </div>
    );
  }
}

export default Planner;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/Planner/index.js